import { getCodeFromErrors } from '@common/components';
import type { ApolloError } from '@common/hooks';

const GENERIC_ERROR = 'Something went wrong. Please try again.';

// NOTE: the copy mutations answer INVALID only for the demand aggregation refusal, whose
// message is a fixed id-free string; every other error keeps the generic copy.
export function copyShiftTimesErrorMessage(error: ApolloError): string {
  if (getCodeFromErrors(error.graphQLErrors) !== 'INVALID') {
    return GENERIC_ERROR;
  }

  return error.graphQLErrors[0]?.message || GENERIC_ERROR;
}
